import { Upload, ScanSearch, Download } from 'lucide-react'
import Section, { Reveal, SectionHeading } from './Section'

const STEPS = [
  { icon: Upload, title: 'Upload the drawing', body: 'Drop in a DXF, DWG, STEP or PDF. GCodr reads the geometry, dimensions and notes.' },
  { icon: ScanSearch, title: 'Review features and tools', body: 'Check the pockets, holes and profiles it found and the tools it picked. Change anything in plain language.' },
  { icon: Download, title: 'Download the G-code', body: 'Get a complete program, verified against your drawing before you download it.' },
]

/** Three numbered GCodr steps in bordered cells. */
export default function HowItWorks() {
  return (
    <Section id="how" labelledBy="how-title">
      <div className="px-5 pt-20 md:px-12 md:pt-28">
        <SectionHeading id="how-title" label="How it works" lead="Upload a drawing." rest="Get a program you can run." />
      </div>
      <ol className="mt-14 grid border-t border-white/[0.07] md:grid-cols-3">
        {STEPS.map(({ icon: Icon, title, body }, i) => (
          <li key={title} className={`border-white/[0.07] ${i > 0 ? 'border-t md:border-l md:border-t-0' : ''}`}>
            <Reveal delay={i * 0.08} className="flex h-full flex-col px-5 py-10 md:px-8">
              <div className="flex items-center justify-between">
                <span className="flex h-10 w-10 items-center justify-center rounded-lg border border-cyan-500/25 bg-cyan-500/[0.06]">
                  <Icon className="h-[18px] w-[18px] text-cyan-400" />
                </span>
                <span className="font-mono text-[11px] tabular-nums text-slate-600">{String(i + 1).padStart(2, '0')} / 03</span>
              </div>
              <h3 className="mt-8 font-display text-xl font-semibold text-slate-100">{title}</h3>
              <p className="mt-2 font-display text-[15px] leading-relaxed text-slate-400">{body}</p>
            </Reveal>
          </li>
        ))}
      </ol>
    </Section>
  )
}
